import { BaseRouteService } from "core/services";

class FacilityOrderTemplateNewFlowRouteService extends BaseRouteService {
    constructor() {
        super("facility-order-templates-new-flow");    
    }    

    find(filter) {
        return super.find(`${this.base}/{?facilityOrderId,itemCategoryId,newFlowUSIntakeStatusIds,patientId}`, filter);
    }
}

export default FacilityOrderTemplateNewFlowRouteService;